import * as S from './FirstGridItem.styles';
export default S.FirstGridItem;